export const LogoMark = ({ size = 36 }) => (
  <svg width={size} height={size} viewBox="0 0 110 100" fill="none" aria-hidden="true">
    <defs>
      <linearGradient id="lg-green" x1="0" y1="0" x2="0.3" y2="1">
        <stop offset="0" stopColor="#8DC63F" />
        <stop offset="1" stopColor="#2F9E36" />
      </linearGradient>
      <linearGradient id="lg-blue" x1="0" y1="1" x2="1" y2="0">
        <stop offset="0" stopColor="#1E9CD7" />
        <stop offset="1" stopColor="#15437E" />
      </linearGradient>
      <linearGradient id="lg-navy" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#1B4A8A" />
        <stop offset="1" stopColor="#102A52" />
      </linearGradient>
    </defs>
    <path
      d="M58 6 C50 9 44 17 40 27 L29 54 C37 47 46 43 53 43 L62 20 C65 12 63 7 58 6 Z"
      fill="url(#lg-green)"
    />
    <path
      d="M29 54 C42 44 58 41 67 45 L60 62 C46 60 32 66 23 79 L17 90 C19 76 23 63 29 54 Z"
      fill="url(#lg-blue)"
    />
    <path
      d="M58 6 C65 6 71 10 74 18 L97 75 C100 83 96 91 88 93 C81 94 75 90 72 83 L52 32 C48 21 50 10 58 6 Z"
      fill="url(#lg-navy)"
    />
  </svg>
);

export const Logo = ({ light = false }) => (
  <span className="inline-flex items-center gap-2">
    <LogoMark />
    <span className={`font-display text-xl font-extrabold tracking-tight ${light ? "text-white" : "text-[#13335E]"}`}>
      ABSL<span className="text-[#3FA535]">pay</span>
    </span>
  </span>
);
